const months = {
    1: 'января',
    2: 'февраля',
    3: 'марта',
    4: 'апреля',
    5: 'мая',
    6: 'июня',
    7: 'июля',
    8: 'августа',
    9: 'сентября',
    10: 'октября',
    11: 'ноября',
    12: 'декабря',
};

export default value => {
    const str = String(value);

    if (str.length != 8) return '';

    const d = parseInt(str.slice(6, 8));
    const m = parseInt(str.slice(4, 6));
    const y = str.slice(0, 4);

    const month = months[m];

    if ( ! month) return '';

    return `${d} ${month} ${y}`;
};
